// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import { setApiMainPath, setMainPath } from '@/api'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueQrcodeReader from 'vue-qrcode-reader'
import VueCarousel from 'vue-carousel'
import * as VueGoogleMaps from "vue2-google-maps";
// url base BACKEND API
//setApiMainPath('https://back.transporte.ssca-colombia.com/api/')
//setApiMainPath('https://back.usc.ssca-colombia.com/api/')
setApiMainPath('https://back.ips.ssca-colombia.com/api/')
//setApiMainPath('http://localhost:8000/api/')
// url base FRONTEND
//setMainPath('https://transporte.ssca-colombia.com/')
//setMainPath('https://usc.ssca-colombia.com/')
setMainPath('https://ips.ssca-colombia.com/')
//setMainPath('http://localhost:8080/')
Vue.use(BootstrapVue)
Vue.use(VueQrcodeReader)
Vue.use(VueCarousel)
Vue.use(VueQrcodeReader)

export const bus = new Vue()

Vue.component('qr-code', VueQRCodeComponent)

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAlFXk0fJsV6kY2MYn7Nhz39fHm0hwUMMw",
    libraries: "places", // necessary for places input
    country: "co"
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  methods: {
    showInfoDialog (mtitle, mbody, maccept, monAccept, mcancel, monCancel, open) {
      let msj = {
        title: mtitle,
        body: mbody,
        accept: maccept,
        cancel: mcancel,
        onAccept: monAccept,
        onCancel: monCancel,
        boolOpen: open
      };
      bus.$emit('showDialog', msj);
    },
    closeInfoDialog(){
      bus.$emit('closeDialog');
    }
  },
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js